<div class="simple-container" [class.extraPadding]="legend">
    <div
        class="dropdown-container"
        [class.borderless]="borderless"
        [class.open]="isOpen"
        [class.disabled]="isDisabled"
        [style.width]="width ? width + 'px' : '100%'"
        [class.smaller]="smaller"
        (click)="openSelector()"
        #selElement>
        <p *ngIf="legend && (hasSelectedOption || isOpen)" class="dropdown-legend" [class.active]="isOpen">
            {{ legend | translate }}
        </p>

        <div class="dropdown-value">
            <div class="selected-text" data-cy="ops-settings-simple-dropdown-field">
                {{ selectedText | translate }}
            </div>

            <mat-icon class="arrow" svgIcon="dropdown-arrow" [class.rotateArrow]="isOpen"> </mat-icon>
        </div>
    </div>
    <ng-container *ngIf="isOpen">
        <div
            class="options-wrapper"
            #selectorElement
            [style.top]="optionsTop"
            [style.left]="optionsLeft"
            [style.width.px]="selElement?.offsetWidth"
            (click)="$event.stopPropagation()">
            <div
                *ngFor="let option of options"
                class="selector-option"
                [class.isSelected]="isOptionSelected(option) && selectionMode === DEFAULT"
                (click)="onSelect(option)">
                <mat-radio-button
                    *ngIf="selectionMode === RADIO"
                    [checked]="isOptionSelected(option)"
                    [value]="option.value"
                    [disabled]="isDisabled">
                </mat-radio-button>

                <mat-checkbox
                    *ngIf="selectionMode === CHECKBOX"
                    [checked]="isOptionSelected(option)"
                    [disabled]="isDisabled"
                    (click)="$event.stopPropagation()"
                    (change)="onSelect(option)">
                </mat-checkbox>

                <div class="option-text" data-cy="ops-settings-simple-dropdown-field-option">
                    {{ option.string | translate }}
                </div>

                <mat-icon
                    *ngIf="selectionMode === DEFAULT && isOptionSelected(option)"
                    class="check-icon"
                    svgIcon="check">
                </mat-icon>
            </div>
        </div>
    </ng-container>
</div>
